<template>
  <div class="header-big clearfix"> 
    
    <div class="left_header clearfix">
      <img class="logo" src="@/assets/logo.svg" alt="">


      <!-- 公司下拉列表 :disabled="item.disabled" -->
      <span v-if="comId" class="aaaaa">
        <el-select @change="changeComId" v-model="comId" filterable size="mini" placeholder="公司名">
          <el-option
            v-for="item in companys"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </span>

      <span v-if="comId" class="dateStyle" style="margin-top: 11px;display: inline-block;">
        <i class="el-icon-date" style="position:relative;left:14px;z-index:99"></i>
        <qzf-period @success="updatePeriods" v-model:period="period"></qzf-period>
      </span>

      <el-popover v-if="comId" v-model:visible="visible" placement="bottom" :width="350">
        <el-input
          v-model="content"
          :rows="4"
          type="textarea"
          placeholder="请输入"
        />
        <div style="text-align: right; margin-top: 10px">
          <el-button size="mini" type="primary" @click="visible = false">取消</el-button>
          <el-button size="mini" type="primary" @click="editNote">确定</el-button>
        </div>
        <template #reference>
          <span style="border:1px solid;border-radius:4px;padding:0px;cursor:pointer;font-size:15px;font-weight:400" @click="smallNotes">
            随手记
            <i class="el-icon-plus"></i>
          </span>
        </template>
      </el-popover>
      
      <span v-if="comId"  style="margin-left:20px;cursor:pointer" @click="ticketOpen">
        <i class="el-icon-edit-outline"></i>
        <span>{{filterStatus(this.piaoStatus)}}</span>
      </span>
      <!-- todo -->

      <ticket-status ref="ticketStatus" :period="period" :comId="comId" @success="getPiaoStatus"></ticket-status>

      <div class="nav1" v-if="!comId">
        <span :class="{cur:item.value == thisNav}" v-for="(item, index) in nav" :key="index" @click="goEtax(item.value, false)">
          <i class="iconfont icon-xinzengkehu" v-if="item.value == '初始建账'"></i>
          <i class="iconfont icon-jizhangkehu" v-if="item.value == '记账核算'"></i>
          <i class="iconfont icon-dianzishuiju" v-if="item.value == '批量申报'"></i>
          {{item.name}}</span>
      </div>
    </div>

    
    <div class="right_header clearfix">

      <!-- <el-dropdown>
        <span class="el-dropdown-link">
          <div class="header-message">
            <i class="el-icon-user"></i>
            <span>{{userName}}</span>
          </div>
        </span>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item>使用说明</el-dropdown-item>
            <el-dropdown-item>系统设置</el-dropdown-item>
            <el-dropdown-item>
              <div @click="logout()" class="header-goback">
                <i class="iconfont icon-tuichu"></i>
                退出
              </div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown> -->

      <div v-if="!comName" class="header-message">
        <i class="iconfont icon-gongsi"></i>
        <span>{{orgName}}</span>
      </div>
  
      <!-- <div v-if="comName" class="header-name" style="margin-top:3px">
        <i class="iconfont icon-qiyexinxi"></i>
        <span>{{comName}}</span>
      </div> -->
      <div class="header-message" @click="messageShow(1)">
        <!-- <el-badge :value="12">       -->
          <!-- 消息具体数值 todo -->
          <i class="iconfont icon-xiaoxizhongxin"></i>
          <span>消息</span>
        <!-- </el-badge> -->
      </div>
      <!-- <div class="header-message common_icon" @click="messageShow(2)">
        <i class="iconfont icon-xiazai"></i>
        <span id="downloadFont">下载</span>
      </div> -->
      <div @click="goback()" v-if="comName" class="header-fanhui">
        <i class="iconfont icon-tuichu"></i>
        返回
      </div>
      <div style="display:inline-block" class="header-message" @click="guanlishezhi" v-if="settingShow">
        <i class="iconfont icon-guanlishezhi"></i>
        管理设置
      </div>


      <!-- <div v-if="!comName" class="header-message" @click="messageShow(1)">
        <i class="el-icon-user"></i>
        <span>{{userName}}</span>
      </div> -->


      <div class="header-goback">
        <el-dropdown trigger="click">
          <span class="el-dropdown-link">
            <i class="el-icon-user"></i>
            {{userName}}
            <i class="el-icon-caret-bottom">
              <arrow-down />
            </i>
          </span>
          <template #dropdown>
            <el-dropdown-menu class="menuStyle">
              <div class="user-header">
                

                <!-- <div class="user-menu" @click="messageShow(1)">
                  <i class="iconfont icon-xiaoxizhongxin"></i>
                  消息
                </div> -->

                <div class="user-menu" @click="messageShow(2)">
                  <i class="iconfont icon-xiazai"></i>
                  下载
                </div>
                <div class="user-menu" @click="goSms">
                  <i class="iconfont icon-yanzhengmajilu"></i>
                  验证码记录
                </div>

                <div class="user-menu" @click="logout()">
                  <i class="el-icon-switch-button"></i>
                  退出
                </div>
              </div>
              
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>


      <!-- <div @click="logout()" class="header-goback">
        <i class="iconfont icon-tuichu"></i>
        退出
      </div> -->
    </div>
    <message ref="message"></message>
  </div>
</template>
<script>
import { updateRead } from '@/api/org.js'
import { companyList, userSaveComId } from "@/api/ea";
import { updatePeriod} from "@/api/login";
import store from "@/store";
import { eaCompanyList ,comMemoryInfo ,comMemorySave ,getDpStatus } from "@/api/company"
import message from "./information.vue";
export default {
  name: "header",
  components: {
    message
  },
  data () {
    return {
      comId: this.$store.getters["user/comInfo"].comId * 1,
      // period: ,//"202201",//
      companyId: {},
      companys: [],
      companysSearch: [],
      filterText: "",
      comName:this.$store.getters["user/comInfo"].comName,
      userName:this.$store.getters['user/user'].cnName,
      orgName:this.$store.getters['user/user'].orgName,
      settingShow:false,
      visible:false,
      content:'',
      dialogVisible:false,
      piaoStatus:2,
      piaoItems:[]
    }
  },
  computed: {
    thisNav(){
      return store.getters['user/model']
    },
    period(){
      return store.getters["user/comInfo"].period
    },
    nav(){
      let nav = []
      let nav2 = []
      if(this.$store.getters["user/user"].primaryRouting){
        console.log(this.$store.getters["user/user"].primaryRouting)
        nav = this.$store.getters["user/user"].primaryRouting.map(v=>{
          if(v == '管理设置'){
            this.settingShow = true
            return
          }
          nav2.push({
            name:v,
            value:v
          })
        })
      }
      return nav2
    },
  },
  created(){
    this.init()
  },
  mounted() {
    updateRead({}).then(response => {
      if(response.data.data.status){
        this.$refs.message.detail = response.data.data.info;
        this.$refs.message.dialogFormVisible = true;
      }
    });
    let param = {
      comId:this.comId,
      period:this.$store.getters["user/comInfo"].period
    }
    this.$refs.ticketStatus.ticketStatus(param)
  },
  // watch: {
  //   filterText(val) {
  //     this.companysSearch = this.companys.filter(v=>{return v.name.indexOf(this.filterText) > -1})
  //   }
  // },
  methods: {
    init(){
      eaCompanyList({status: "2"}).then(res=>{
        this.companys = res.data.data.list
      })
    },
    getPiaoStatus(e){
      this.piaoStatus = e
    },
    filterStatus(val){
      if(val == 9){
        return '未到票'
      }else if(val == 2){
        return '全部到票'
      }else if(val == 1){
        return '部分到票'
      }
    },
    goback(){
      // opener: 谁打开我的, 注意它不是parent!!
      if (window.opener) { // 主页面还存在
        // 关闭当前页
        // 切换到主页面 how ?
        // window.open(window.opener.location.href,  '_parent'); // 可以, 因为当前页面没有parent
        window.close()
      } else { // 主页面已经关了
        // location.reload() 
        window.open(location.origin,  '_blank');
        window.close();
      }
    },
    changeComId(){
      this.$store.dispatch("user/setComInfo", {
        comId: this.comId,
      })
      window.name = this.comId + "##accountBook"
      this.goEtax("正常", true)
    },
    goEtax(e, force){
      //为了防止重复调用 userInfo 做个判断
      if(store.getters["user/model"] == e && !force){
        this.gogogo(e)
        return
      }
      this.$store.dispatch("user/setModel", e)
      this.$store.dispatch('user/GetUserInfo').then(res=>{
        // getRouter(res.roles)
        this.$store.dispatch('router/SetAsyncRouter',res.roles).then(res=>{
          this.$store.dispatch('tagsView/delAllViews')
          this.gogogo(e)
        })
      }).catch(err=>{
        //有问题 返回登录页面 直接清空token 就可
        // removeToken()
        // location.reload()
      })
    },
    gogogo(e){
      if(e == "正常"){
          this.$router.replace({
              path: '/redirects',
              query: {
                path: '/etaxHome/etaxHomeIndex',
              },
          })
        }else{
          this.$router.replace({
            path: '/redirects',
            query: {
              path: store.getters["user/indexPath"],
            },
          })
        }
    },
    //更改账期
    updatePeriods(data){
      let comInfo = store.getters["user/comInfo"]
      comInfo.period = data.period
      updatePeriod({period: data.period}).then(res=>{
        if(res.data.msg == "success"){
          comInfo.comType = res.data.data.info.comType
          comInfo.comKj = res.data.data.info.comKj
          this.$store.dispatch("user/setComInfo", comInfo)
          //刷新
          this.$store.dispatch("tagsView/delAllViews"); //关闭
          // this.$router.push('/'); //lcs账期
          if(data.old){
            this.goEtax("历史", false)
          }else{
            this.goEtax("正常", false)
          }
        }
      })
    },
    //消息
    messageShow(e){
      this.tabName = e
      this.$refs.message.showBig2(this.tabName)
    },
    logout(){
      this.$store.dispatch('user/LogOut').then(() => {
        location.reload()
      })
    },
    guanlishezhi(){
      this.goEtax('管理设置',false)
    },
    smallNotes(){
      this.visible = true
      comMemoryInfo({}).then(res=>{
        this.content = res.data.data.content
      })
    },
    editNote(){
      comMemorySave({content:this.content}).then(res=>{
        if(res.data.msg == "success"){
          this.visible = false
          this.$qzfMessage("保存成功")
        }
      })
    },
    ticketOpen(){
      this.$refs.ticketStatus.openDialog()
      let params = {
        comId: this.$store.getters["user/comInfo"].comId * 1,
        period: this.$store.getters["user/comInfo"].period
      }
      this.$refs.ticketStatus.ticketStatus(params)
    },
    goSms(){
      this.$router.push({
        path: "/ea-setting/sms",  
      });
    }
  },
  
}
</script>

<style lang="scss" scoped>
.company-span .el-select .el-input__inner{
  border:0 !important;
  padding-right: 30px;
}
.company-span .el-input__inner{
  padding: 0 6px !important;
}
.company-span .el-input__inner{
  position: relative;
  top: -3px;
}
.company-span .el-input__suffix {
  top: -2px;
}
.header-big {
  .el-dropdown-selfdefine{
    color: $color-header-color;
  }
}
.user-header{
  width: 120px;
  .user-menu{
    color: $color-header-color !important;
    display: inline-block;
    width: 100%;
    height: 35px;
    font-size: 14px;
    font-weight: 300;
    // padding-left: 10px;
    line-height: 30px;
    border-bottom: 1px solid #2c3445;
    cursor: pointer;
    &:last-child{
      border-bottom: none;
    }
  }
  border: none;
}


</style>
<style lang="scss" scoped>
.header-big{
  position: relative;
  width: 100%;
  height: 56px;
  padding: 0 15px 0 0px;
  border-bottom: 1px solid #eee;
  background: #373f50;
  color: $color-header-color;
  
  .logo{
    // position: absolute;
    // top: 3px;
    // left: 27px;
    margin-top: 0px;
    float: left;
    width: 200px;
    height: 53px;
    font-size: 14px;
  }
  .left_header{
    float: left;
    
  }
  .right_header{
    float: right;
    padding-top: 10px;
    span{
      font-size: 16px;
      font-weight: 400;
    }
    
  }
  .header-name{
    float: left;
    i{
      vertical-align: top;
      color: $color-header-color;
      line-height: 25px;
    }
    span{
      // vertical-align: top;
      font-size: 15px;
      margin-left: 5px;
      color: $color-header-color;
    }
    margin-right: 10px;
  }
  .header-message {
    float: left;
    font-size: 16px;
    cursor: pointer;
    line-height: 28px;
    color: theme;
    color: $color-header-color;
    padding-right: 16px;
    margin-top: 2px;
  }
  .header-goback{
    float: left;
    font-size: 17px;
    cursor: pointer;
    line-height: 34px;
    color: $color-header-color;
  }
  .header-fanhui{
    float: left;
    font-size: 15px;
    cursor: pointer;
    line-height: 34px;
    color: $color-header-color;
    width: 80px;
    height: 35px;
    text-align: center;
    // border: 1px solid white;
    border-radius: 6px;
    margin-right: 10px;
  }
}
.company-span{
  height: 30px;
  i{
    line-height: 30px;
    color: #666;
  }
}
.company{
  min-width: 300px;
  height: 30px;
}
.el-icon-printer{
  vertical-align: sub;
}
.nav1{
  display: inline-block;
  padding: 0px;
  margin-left: 3px;
  span{
    color: $color-header-color;
    font-size: 16px;
    display: inline-block;
    width: 135px;
    font-weight: 500;
    line-height: 52px;
    position: relative;
    text-align: center;
    box-sizing:border-box;
    cursor: pointer;
    // }
    // &::before {
    //   width: 1px;
    //   background: #c2c2c2;
    //   content: " ";
    //   clear: both;
    //   height: 30px;
    //   position: absolute;
    //   top: 10px;
    //   left: 0;
    // }
    // &:last-child{
    //   &::after {
    //     width: 1px;
    //     background: #c2c2c2;
    //     content: " ";
    //     clear: both;
    //     height: 30px;
    //     position: absolute;
    //     top: 10px;
    //     right: 0;
    //   }
    // }
  }
}
.cur{
  border-bottom: 3px solid $color-main;
}
.menuStyle{
  text-align: center;
}

</style>

<style lang="less" scoped>
.el-scrollbar .el-dropdown-menu{
  padding: 0px;
  background: #373f50;
  border-radius: 0px;
}
.el-scrollbar .el-dropdown-menu{
  padding: 0px;
  background: #373f50;
  border-radius: 0px;
}
// .el-scrollbar .el-dropdown-menu .el-dropdown-menu__item :hover{
//   color: white;
//   border-bottom: 1px solid white;
// }
</style>
<style lang="scss">
.aaaaa{
.el-input__inner{
    background-color: #2C3445;
    width:255px;
    color: #fff;
    border: none;
    font-size: 15px;
    font-weight: 500;
  }
}
.dateStyle{
.el-input__inner{
    background-color: #373f50;
    color: #fff;
    border: none;
    font-size: 15px;
    width: 136px;
    font-weight: 500;
  }
}
</style>